import React, { ReactNode } from "react";
import styled from "styled-components/macro";
import Typography from "ui/Typography";
import IconCircleButton from "ui/IconCircleButton";
import { useNavigate } from "react-router-dom";
import { theme } from "ui/theme";
import logout from "utils/logout";
import WhiteRipBorder from "images/white_page_rip.svg";
import AlongLogo from "components/AlongLogo/AlongLogo";
import Button from "ui/Button/Button";
import { EventName } from "utils/analytics/analyticsConstants";

const $Wrapper = styled.div`
  height: 6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;

  &:before {
    content: "";
    background-image: url("${WhiteRipBorder}");
    width: 100%;
    height: 9rem;
    position: absolute;
    top: -0.5rem;
    left: 0;
    background-size: cover;
  }
`;

const $BackButtonWrapper = styled.div`
  position: absolute;
  left: 1.5rem;
`;

const $SignOutButton = styled(Button)`
  position: absolute;
  right: 3rem;
`;

const $HeaderTextWrapper = styled.div`
  text-align: center;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;
  z-index: ${theme.zIndexLevelOne};
  @media screen and (${theme.BreakpointPhoneDown}) {
    margin-left: 5rem;
  }
`;

export interface HeaderProps {
  title?: string;
  subtitle?: string;
  hideExploreMode: boolean;
  showSignout?: boolean;
  backButton?: ReactNode;
  className?: string;
}

Header.defaultProps = {
  hideExploreMode: false,
};

export default function Header(props: HeaderProps) {
  const navigate = useNavigate();

  const backButton = props.backButton ? (
    <$BackButtonWrapper>{props.backButton}</$BackButtonWrapper>
  ) : (
    <$BackButtonWrapper>
      <IconCircleButton
        icon="back"
        ariaLabel="Go back"
        analyticsName={EventName.Header.CLICKED_PAGE_HEADER_BACK_BUTTON}
        onClick={() => navigate(-1)}
      />
    </$BackButtonWrapper>
  );

  return (
    <$Wrapper className={props.className}>
      {props.hideExploreMode ? (
        <$SignOutButton
          requestInProgress={false}
          variant="secondary"
          analyticsName="logged_out"
          onClick={() => {
            logout("/?intent=expedited_educator_onboarding");
          }}
        >
          {" "}
          Sign Out
        </$SignOutButton>
      ) : (
        backButton
      )}
      <$HeaderTextWrapper>
        {props.title ? (
          <Typography size="h3" as="h1">
            {props.title}
          </Typography>
        ) : (
          <AlongLogo variant="along-2" />
        )}
      </$HeaderTextWrapper>
      {props.showSignout && (
        <$SignOutButton
          requestInProgress={false}
          variant="secondary"
          analyticsName="logged_out"
          onClick={() => logout()}
        >
          {" "}
          Sign Out
        </$SignOutButton>
      )}
    </$Wrapper>
  );
}
